import { getters } from './getters';
import * as actions from './actions';
import { mutations } from './mutations';
import { menuRenderInitialState } from './constants';

export const menuRenderModule = {
  state: menuRenderInitialState,
  getters,
  actions,
  mutations,
};
